import React from 'react';
import { LuChevronDown } from 'react-icons/lu';
import { horaTexto, nombreVisita } from '../../utils/ordenes';

// Visita de un día que no es hoy, en dos renglones (31-oct-2026). Antes cada visita de la semana salía con la
// tarjeta completa (equipos, chat, instrucciones y "Salir") y entraba una por pantalla. Tocándola se abre la
// tarjeta completa, con su propio "Ok, voy" y "Hubo un problema".
export default function VisitaResumen({ orden, color, onAbrir }) {
    const tentativa = !!orden.sinConfirmar && orden.estado === 'PENDIENTE';
    // 4-nov-2026: el "Ok, voy" va una sola vez en el día (MisOrdenes); acá solo se marca lo confirmado
    const { nombre, motivo } = nombreVisita(orden);
    const segunda = [orden.clienteNombre && !String(orden.titulo || '').includes(orden.clienteNombre) ? orden.clienteNombre : null, orden.direccion]
        .filter(Boolean).join(' · ');
    return (
        <div id={`orden-${orden.id}`} role="button" tabIndex={0} onClick={() => onAbrir(orden.id)}
            onKeyDown={(e) => { if (e.key === 'Enter') onAbrir(orden.id); }}
            className="flex items-center gap-3 px-3 py-2.5 rounded-2xl bg-card border border-black/10 dark:border-white/[0.12] active:scale-[0.99] cursor-pointer"
            style={{ borderLeft: `6px solid ${tentativa ? 'var(--warning-tx)' : orden.propia ? '#7C3AED' : color}` }}>
            <div className="w-14 shrink-0 text-center">
                <p className="text-body font-black text-ink leading-tight">{orden.horaEstimada ? horaTexto(orden.horaEstimada) : '—'}</p>
            </div>
            <div className="flex-1 min-w-0">
                <p className="text-body font-black text-ink truncate">{nombre}{motivo && <span className="font-bold text-muted"> · {motivo}</span>}{orden.propia && <span className="ml-1.5 px-1.5 py-0.5 rounded-md text-[10px] font-black text-[#7C3AED] bg-[rgba(124,58,237,0.15)]">TUYO</span>}</p>
                {segunda && <p className="text-caption text-muted truncate">{segunda}</p>}
            </div>
            {tentativa
                ? <span className="shrink-0 text-label font-black text-[var(--warning-tx)]">⏳ A confirmar</span>
                : orden.confirmadaEn ? <span className="shrink-0 text-label font-black text-[#16A34A]">✓</span> : null}
            <LuChevronDown size={16} className="shrink-0 text-muted" aria-hidden />
        </div>
    );
}
